import classNames from 'classnames';
import { T } from '~/components/I18n';
import { BottomSheet, BottomSheetProps } from '~/components/Modal/BottomSheet';
import { TermLink } from '~/components/Term/Link/TermLink';
import styles from './MpAgreeBottomSheet.module.scss';
export type MpAgreeBottomSheetProps = BottomSheetProps;
const DOSI_MEMBERS_URL = import.meta.env.VITE_DOSI_MEMBERS_URL;

export const MpAgreeBottomSheet = ({ className, ...props }: MpAgreeBottomSheetProps) => (
  <BottomSheet
    {...props}
    title={<T name="dosi_mp_agree_popup_title" />}
    description={<T name="dosi_mp_agree_popup_desc" />}
    className={classNames(styles.root, className)}
    confirmButton={undefined}
    dismissButton={undefined}
    dismissText={<T name="citizen_checkin_complete_confirm" />}
    confirmText={<T name="dosi_mp_agree_popup_btn" />}
    // data-event="impression"
    // data-event-category="mp_consent_bottomsheet"
    data-event-impression-id="{category}">
    <TermLink className={styles.link} href={`${DOSI_MEMBERS_URL}/terms/marketing_policy/mp`}>
      <T name="dosi_mp_agree_popup_link_1" />
    </TermLink>
  </BottomSheet>
);
